// TODO(Babel 8): This won't be needed anymore

// prettier-ignore
export default {
  __proto__: null,
  "transform-class-static-block": "proposal-class-static-block",
  "transform-private-property-in-object": "proposal-private-property-in-object",
  "transform-class-properties": "proposal-class-properties",
  "transform-private-methods": "proposal-private-methods",
  "transform-numeric-separator": "proposal-numeric-separator",
  "transform-logical-assignment-operators": "proposal-logical-assignment-operators",
  "transform-nullish-coalescing-operator": "proposal-nullish-coalescing-operator",
  "transform-optional-chaining": "proposal-optional-chaining",
  "transform-json-strings": "proposal-json-strings",
  "transform-optional-catch-binding": "proposal-optional-catch-binding",
  "transform-async-generator-functions": "proposal-async-generator-functions",
  "transform-object-rest-spread": "proposal-object-rest-spread",
  "transform-unicode-property-regex": "proposal-unicode-property-regex",
  "transform-export-namespace-from": "proposal-export-namespace-from",
};
